import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Editor from "@monaco-editor/react";

const isValidJson = (value: string): boolean => {
  try {
    JSON.parse(value);
    return true;
  } catch {
    return false;
  }
};

interface JsonEditorDialogProps {
  visible: boolean;
  onClose: () => void;
  onSave: (newValue: string) => void;
  initialValue?: string;
  title?: string;
}

const JsonEditorDialog: React.FC<JsonEditorDialogProps> = ({
  visible,
  onClose,
  onSave,
  initialValue = "",
  title = "JSON Editor",
}) => {
  const [value, setValue] = useState<string>("");
  const [isValid, setIsValid] = useState<boolean>(true);

  useEffect(() => {
    try {
      const parsed = JSON.parse(initialValue);
      setValue(JSON.stringify(parsed, null, 2));
      setIsValid(true);
    } catch {
      setValue("");
      setIsValid(false);
    }
  }, [initialValue]);

  const handleSave = () => {
    if (isValidJson(value)) {
      onSave(value);
      onClose();
    }
  };

  const footer = (
    <div className="flex justify-end gap-2">
      <Button label="Annuler" className="m-2 p-button-sm" onClick={onClose} />
      <Button
        label="Sauvegarder"
        className="m-2 p-button-outlined p-button-sm"
        onClick={handleSave}
        disabled={!isValid}
      />
    </div>
  );

  return (
    <Dialog
      header={title}
      visible={visible}
      onHide={onClose}
      style={{ width: "80vw" }}
      footer={footer}
      modal
    >
      <Editor
        height="400px"
        defaultLanguage="json"
        value={value}
        onChange={(val) => {
          const newVal = val || "";
          setValue(newVal);
          setIsValid(isValidJson(newVal));
        }}
        options={{
          minimap: { enabled: false },
          formatOnType: true,
          formatOnPaste: true,
        }}
      />
      {!isValid && (
        <div className="mt-2 text-red-500 font-medium">
          Le JSON n'est pas valide.
        </div>
      )}
    </Dialog>
  );
};

export default JsonEditorDialog;
